var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileBlueLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DBE7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#E9F0FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 11.334H13.9974C13.6438 11.334 13.3046 11.4745 13.0546 11.7245C12.8045 11.9746 12.6641 12.3137 12.6641 12.6673V23.334C12.6641 23.6876 12.8045 24.0267 13.0546 24.2768C13.3046 24.5268 13.6438 24.6673 13.9974 24.6673H21.9974C22.351 24.6673 22.6902 24.5268 22.9402 24.2768C23.1903 24.0267 23.3307 23.6876 23.3307 23.334V16.0007M18.6641 11.334L23.3307 16.0007M18.6641 11.334V16.0007H23.3307",
    stroke: "#1F44DD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlueLg);
export default __webpack_public_path__ + "static/media/file_blue_lg.f26aa1fbd87d53d4daf981bc9e47db8b.svg";
export { ForwardRef as ReactComponent };